import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
class FieldSurveyDashboard extends React.Component {
    

  render() {
    return (
      <div style={{ margin: 20, textAlign: "center" }}>
        <a
          tabIndex="0"
          onClick={
            document.getElementById("singleTitle")
              ? document.getElementById("singleTitle").focus()
              : undefined
          }
        >
          Search something!
        </a>
      </div>
    );
  }
}
FieldSurveyDashboard.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.object.isRequired
};
const mapStateToProps = state => {
  return {
    isFetching: state.search.isFetching,
    items: state.search.items
  };
};
export default withRouter(
  connect(
    mapStateToProps
  )(FieldSurveyDashboard)
);
